export default __webpack_public_path__ + "static/content-containers-light-4b18271ae3fa3e27f5928297dfb2231d5e619f683574a48109c6fd05584ab1c9.png";